import { DefaultTheme } from 'styled-components/macro';
import { common } from './common';

export const payflip: DefaultTheme = Object.assign(
  { ...common },
  {
    /* Override theme here */
  }
);
